module.exports = __webpack_public_path__ + "res/puzzle.d1bacbd9c05be9e65d874ce81bf9eaa4.webp";